module.exports = __webpack_public_path__ + "static/IMG-20200905-WA0007-714d24ff7d2d815215665a28a79ff502.jpg";